// extracted by mini-css-extract-plugin
module.exports = {"card":"ServiceCard_card__2z5tl","card__btn":"ServiceCard_card__btn__2x1ng","card__title":"ServiceCard_card__title__eWFEs","card__text":"ServiceCard_card__text__3Lj8c"};